import React, { FC } from 'react'
import componentStyles from './MediaMenu.module.scss'
import SpotlightButton from '../SpotlightButton'
import ScreenShareButton from '../ScreenShareButton'
import PlayInButton from '../PlayInButton'
import SlidesButton from '../SlidesButton'
import StreamButton from '../EventStreaming/StreamButton'
import { MediaMenuProps } from './types'

const MediaMenu: FC<MediaMenuProps> = props => {

  return <div className={componentStyles['MediaMenu']}>
    <ul className={componentStyles['_list']} >
      {props.spotlightEnabled && <SpotlightButton />}
      {props.slidesEnabled && <SlidesButton />}
      {props.playInEnabled && <PlayInButton />}
      {props.screenshareEnabled && <ScreenShareButton />}
      {props.streamEnabled && <StreamButton />}
    </ul>
  </div>

}

export default MediaMenu
